const svgPaths = {
  // Map pin outer and inner shapes (approximate)
  p28474700:
    "M12 2C8.686 2 6 4.686 6 8c0 4.5 6 12 6 12s6-7.5 6-12c0-3.314-2.686-6-6-6zm0 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4z",
  p193f6900:
    "M12 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4z",
  // Arrow right
  p35129400:
    "M5 12h10M11 6l6 6-6 6",
};

export default svgPaths;

